<template>
  <div style="background: #f1f8fe;">
    <Mheader v-if="isMobile"></Mheader>
    <Pcheader v-if="!isMobile"></Pcheader>
    <div class="container">
      <div class="article"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
        <div>
          <p class="article_tit" v-if="!loading">— 高校校招信息 —</p>
        </div>
        <div>
          <ul class="article_ul">
            <li v-for="(item, index) in articles" :key="index">
              <a :href="item.link_url" target="_blank" :title="item.title">
                <p>{{item.title}}</p>
              </a>
            </li>
          </ul>
          <el-link v-if="!loading" type="danger" href="https://www.jxrsrc.com/article/cid/31" target="_blank" style="float:right"> <div class="more">更多></div></el-link>
          <div style="clear: both;"></div>
        </div>
      </div>
      <div class="search_wrapper clearfix">
            <div class="jobfair_search_box float clearfix">
                <div class="clearfix float" style="box-shadow: 3px 3px 8px 1px #eaeaea;">
                    <div class="search_select float">
                        <el-select v-model="province_id" placeholder="全国"  @change="handleClass">
                          <el-option
                            v-for="item in classify"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        </div>
                        <div class="search_input float">
                            <input type="text" placeholder="请输入关键字" v-model="uniname" />
                            </div> 
                            <div class="search_btn float">
                            <button type="button" @click="doSearch">搜索</button>
                        </div>
                 </div>
        </div> 
        </div>
      <div class="main">
        <div class="section web">
          <div class="list">
            <ul id="divlist">
              <li v-for="(item, index) in dataset" :key="index">
                <div class="firm">
                  <a :href="item.homelink" target="_blank">
                    <el-image :src="item.logourl">
                      <div slot="error" class="image-slot">
                        <img src="https://www.jxrsrc.com/upload//UpLoadPic_P/P00/0/P000219.jpg" alt=""
                          style="height:88px">
                      </div>
                    </el-image>
                    <p>
                      <b>{{ item.uniname }}</b>
                      <span v-if="item.holdtime">举办时间：{{ item.holdtime }}</span>
                      <!-- <span v-if="!item.holdtime">举办时间：暂无</span> -->
                    </p>
                  </a>
                </div>
                <div class="btns">
                  <a :href="item.homelink" target="_blank">点击查看详情>></a>
                </div>
              </li>
            </ul>
            <p v-if="searchjob_loading" style="text-align:center;padding-bottom:12px;font-size: 14px;color:#868686">加载中...</p>
            <p v-if="searchjob_noMore" style="text-align:center;padding-bottom:20px;font-size: 14px;color:#868686">没有更多了</p>
          </div>
          <el-empty description="暂时没有数据哦" v-if="isEmpty"></el-empty>
        </div>
      </div>
      <div class="footer" v-if="searchjob_noMore||isEmpty||isLessEmpty">
        <span>©2022 嘉兴人事人才网版权所有</span>
      </div>
    </div>
  </div>
</template> 

<script>
import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Mheader from "../component/mheader.vue";
import Pcheader from "../component/Pcheader.vue";
import { isMobile } from "@/utils/isMobile";
import { selfRequest_gsd,selfRequestGetClassify,selfRequestGetArticle } from "@/api/discoverydata";
Vue.use(ElementUI);
export default {
  name: "PcIndex",
  components: { Mheader,Pcheader },
  data() {
    return {
      query_id: "",
      isEmpty:false,
      isLessEmpty:false,
      province_id:'',
      isMobile:false,
      uniname:'',
      dataset: {},
      loading:true,
      page: 1,
      searchjob_noMore: 0,
      searchjob_loading: 0,
      searchTab:'全国',
      search_type:'companyname',
      keyword:'',
      classify:[],
      articles:[]
    };
  },
  created() {
    if(isMobile()){
      this.isMobile = true
    }
    else{
      this.isMobile = false
    }
    
    
    selfRequest_gsd({ page: this.page }).then((res) => {
      this.dataset = res.data.items
    });
    
    selfRequestGetClassify().then((res) => {
      var temp = [{
        label:'全国',
        value:''
      }]
      this.classify = temp.concat(res.data)
    });

    selfRequestGetArticle().then((res) => {
      this.articles = res.data.items
      this.loading = false
    });
  },
  mounted() {
    window.addEventListener('scroll', this.windowScroll, true) //监听页面滚动
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.windowScroll);//销毁滚动事件
  },
  methods: {
    //获取当前可视范围的高度
    getClientHeight: function () {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
      }
      return clientHeight
    },

    //获取文档完整的高度
    getScrollHeight: function () {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
    },

    //获取当前滚动条的位置
    getScrollTop: function () {
      var scrollTop = 0;
      //window.pageYOffset = document.documentElement.scrollTop
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      // console.log(scrollTop)
      return scrollTop
    },

    windowScroll: function () {
      //获取三个值
      var scrollTop = this.getScrollTop()
      var clientHeight = this.getClientHeight()
      var scrollHeight = this.getScrollHeight()
      //如果满足公式则，确实到底了
      if (((scrollTop + 1) + clientHeight > (scrollHeight - 20)) && (scrollTop !== 0) && !this.isShowEmpty) {
        //发送异步请求请求数据，同时携带offset并自增offset
        //noMore是自定义变量，如果是最后一批数据则以后都不加载
        //  alert('触发')
        var t = this;
        t.page += 1
        if (!t.searchjob_noMore&&!this.isEmpty) {
          t.searchjob_loading = 1
          selfRequest_gsd({ page: t.page,uniname:t.uniname, province_id:t.province_id }).then((res) => {
            if (res.data.items.length) {
              var temp = res.data.items
              t.dataset = t.dataset.concat(temp)
              t.searchjob_loading = 0
            }
            else {
              if(!t.isEmpty){
                t.searchjob_noMore = 1
                t.searchjob_loading = 0
              }
              else{
                t.searchjob_loading = 0
              }
            }
          }).catch(function (err) { console.log(err) });
        }
      }
    },
    handleCommand:function(command) {
                if(command=='a'){
                    this.searchTab = '企业名称'
                    this.search_type = 'companyname'
                }
                else{
                    this.searchTab = '职位名称'
                    this.search_type = 'companyjob'
                }
                
             },
      handleClass:function(value){
      this.province_id = value
      this.doSearch()
    },
     doSearch:function(){
      this.page = 1
      this.searchjob_noMore = 0
      this.isEmpty = false
      selfRequest_gsd({ page: this.page,uniname:this.uniname, province_id:this.province_id}).then((res) => {
        if (res.data.items.length>=4){
          this.dataset = res.data.items
        }
        else if(res.data.items.length>0&&res.data.items.length<4){
          this.isLessEmpty = true
          this.dataset = res.data.items
        }
        else{
          this.dataset = []
          this.searchjob_noMore = 0
          this.isEmpty = true
        }
    });
     }
  },
};
</script>
<style>
.article{
  width: 1200px;
  margin: 20px auto 60px;
  padding: 30px 30px 10px 30px;
  background: #fff;
  border: 1px solid #4a72cb;
  min-height: 331px;
}
.article_ul a:hover{
  color: #2d8bf0;
  text-decoration: underline;
}
.article .article_tit{
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 30px;
}
.article ul{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}
.article li{
  width:495px;
  height: 40px;
  line-height: 40px;
  float: left;
  color: #404c5b;
  cursor: pointer;
  text-align: left;
}
.article li p {
  width: 500px;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.article .more{
  width: 40px;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  color: red;
  float: right;
}

.el-input__icon{
  line-height: 45px;
}
.el-input__inner{
  border: none;
}
input::input-placeholder{
	color:#606266 !important;
}
input::-webkit-input-placeholder{
	color:#606266 !important;
}
input::-moz-placeholder{
	color:#606266 !important;
}
input::-ms-input-placeholder{
	color:#606266 !important;
}
.el-image__inner{
  height: 188px;
  width: auto;
}
@media screen and (max-width: 870px){
  .el-image__inner{
  height: 50px;
}
}
</style>
<style scoped>
 input:focus{
  outline: none;
 }
.float{
  float: left;
}
.search_wrapper {
    border-radius: 5px;
    width: 1200px;
    margin: auto;
    height: 46px;
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.jobfair_search_box {
    background: #fff;
}
.jobfair_search_box .search_select {
    width: 150px;
    height: 46px;
    line-height: 46px;
    cursor: pointer;
    position: relative;
    padding-left: 28px;
    padding-right: 16px;
}
.jobfair_search_box .select_hover_box {
    width: 100%;
    background: #fff;
    border: 1px solid #e2e2e2;
    text-align: center;
    display: none;
    position: absolute;
    left: 0;
    top: 46px;
    z-index: 10;
}
.jobfair_search_box .select_hover_box li {
    padding: 5px 0;
}

.jobfair_search_box .search_input input {
    width: 350px;
    border: none;
    border-left: 1px solid #ededed;
    height: 20px;
    padding-left: 20px;
    margin-top: 13px;
}
.jobfair_search_box .search_btn button {
    width: 110px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    background: #1787fb;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    border: none;
}
.clearfix {
    *zoom: 1;
}
.clearfix:after, .clearfix:before {
    content: "";
    display: table;
}
.el-image img {
  height: 88px !important;
}

.container {
  width: 100%;
}

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 60px auto;
}

.main .section {
  display: flex;
  flex-direction: column;
  width: 1200px;
}

.web .list {
  display: flex;
  flex-direction: column;
}

.web .list ul {
  display: flex;
  flex-wrap: wrap;
}

.web .list li {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 282px;
  padding: 0 20px;
  border-radius: 10px;
  margin-right: 24px;
  margin-bottom: 24px;
  background-color: #fff;
}
.web .list li:nth-child(4n) {
    margin-right: 0;
}
.web .list li .firm {
  display: flex;
  flex-direction: column;
}

.web .list li .firm a {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0 20px;
}

.web .list li .firm a img {
  display: flex;
  flex: 0 0 88px;
  height: 188px;
  border-radius: 10px;
}

.web .list li .firm a p {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.web .list li .firm a p b {
  margin: 20px 0 12px;
  max-width: 242px;
  font-size: 16px;
  color: #333;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.web .list li .firm a p span {
  font-size: 14px;
  color: #999;
  line-height: 14px;
}

.web .list li .btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;
}

.web .list li .btns a {
  display: flex;
  padding-right: 15px;
  /* background: url(../img/more_hover.png) no-repeat right; */
  font-size: 13px;
  color: #999;
  line-height: 13px;
}

.footer {
  background-color: #6288e1;
  font-size: 14px;
  color: #fff;
  line-height: 66px;
  text-align: center;
}
/*屏幕小于870px*/
@media screen and (max-width: 870px) {
  .article{
    width: 374px;
    margin: 8px auto;
    border-radius: 8px;
    min-height: 516px;
  }
  .article li{
    width: 390px;
  }
  .article li p{
    width: 320px;
  }
  .article .article_tit{
    font-size: 18px;
    margin: 0 0 20px;
  }
  .main {
    margin: 8px auto;
    min-height: 485px;
  }

  .main .section {
    width: 100%;
  }

  .web .list li {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 20px;
    border-radius: 8px;
    margin: 10px;
    background-color: #fff;
  }

  .web .list li .firm a {
    flex-direction: row;
    padding: 1.5rem;
  }

  .el-image img {
    height: 50px !important;
  }
  .el-image__inner {
    height: 50px !important;
}
  .web .list li .firm a p {
    align-items: flex-start;
    margin-left: 20px;
  }

  .web .list li .firm a p b {
    margin: 0px 0px 14px 0px;
  }
  .search_wrapper{
    margin-top: 20px;
    width: 390px;
  }
  .jobfair_search_box{
    margin-left: 0;
  }
  .jobfair_search_box .search_input input{
    width: 140px;
  }
  .jobfair_search_box .search_btn button{
    width: 80px;
  }
}</style>
